import { useMemo } from "react";
import Addicon from "@mui/icons-material/Add";
import UserLineIcon from "remixicon-react/UserLineIcon";
import { Button as UIButton } from "@mui/material";

import { InfoContainer, Text } from "$components";
import JTable from "$components/JTable/JTable";
import { User } from "$types/User";
import useStyles from "./useStyles";

type Props = {
  handleAddUserClick: () => void;
  handleEditUserClick: (user: User) => void;
  users: User[];
};

const tableColumns = [
  {
    id: "contact",
    Header: "contact",
    Cell: ({ row }: any) => row.original.contact,
  },
  {
    id: "email",
    Header: "e-mail",
    Cell: ({ row }: any) => row.original.email,
  },
  {
    id: "phone",
    Header: "tél. mobile",
    Cell: ({ row }: any) => row.original.phone,
  },
  {
    id: "isUser",
    Header: "utilisateur",
    Cell: ({ row }: any) => row.original.isUser,
  },
];

function Contacts({ handleAddUserClick, handleEditUserClick, users }: Props) {
  const classes = useStyles();

  const tableData = useMemo(
    () =>
      users?.map((u) => ({
        contact: (
          <Text type="important">
            {u.firstname} {u.lastname}
          </Text>
        ),
        email: <Text>{u.email}</Text>,
        phone: <Text>{u.phone || "N/A"}</Text>,
        isUser: <Text>{u.isOnlyContact ? "Non" : "Oui"}</Text>,
        _user: u,
      })) ?? [],
    [users]
  );

  return (
    <div style={{ display: "flex" }}>
      <InfoContainer
        isToggleable
        leftHeader={
          <div className={classes.infoHeader}>
            <UserLineIcon />
            <Text type="h3">Contacts</Text>
          </div>
        }
        rightHeader={
          <UIButton
            onClick={handleAddUserClick}
            style={{ textTransform: "none" }}
            className={classes.textButton}
          >
            <Addicon />
            <Text>Ajouter un contact</Text>
          </UIButton>
        }
      >
        <JTable
          data={tableData}
          columns={tableColumns}
          setPageIndex={() => {}}
          hideCheckboxes
          hideFilters
          usePaper={false}
          className={classes.noPaddingTable}
          noDataText="Cet entrepôt n'a pas encore de contacts"
          rowProps={(row) =>
            row.original._user.isDisable
              ? { className: "nopointer" }
              : {
                  onClick: () => handleEditUserClick(row.original._user),
                  style: { cursor: "pointer" },
                }
          }
        />
      </InfoContainer>
    </div>
  );
}

export default Contacts;
